import JwtDecode from 'jwt-decode'

export default class User {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new User(obj)
    } catch (_) {
      return null
    }
  }

  constructor ({ aud, exp, iat, jti, nbf, scopes, sub }) {
    this.id = sub // eslint-disable-line camelcase
    this.scopes = scopes
    this.tokenExpire = exp
    this.admin = scopes.includes('admin')
  }

  get isAdmin () {
    return this.admin
  }
}



// WEBPACK FOOTER //
// ./src/models/User.js